import { render, staticRenderFns } from "./OfflineMessageForm.vue?vue&type=template&id=099341b8&scoped=true"
import script from "./OfflineMessageForm.vue?vue&type=script&lang=js"
export * from "./OfflineMessageForm.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./OfflineMessageForm.vue?vue&type=style&index=0&id=099341b8&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "099341b8",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099341b8')) {
      api.createRecord('099341b8', component.options)
    } else {
      api.reload('099341b8', component.options)
    }
    module.hot.accept("./OfflineMessageForm.vue?vue&type=template&id=099341b8&scoped=true", function () {
      api.rerender('099341b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OfflineMessageForm.vue"
export default component.exports